module.exports = __webpack_public_path__ + "static/img/clear_target.f4388292.svg";